var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFuelOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,17.25L17.75,22L15,19L16.16,17.84L17.75,19.43L21.34,15.84L22.5,17.25ZM13.318,21L4,21L4,5C4,3.89 4.89,3 6,3L12,3C13.1,3 14,3.89 14,5L14,12L15,12C15.894,12 16.657,12.588 16.882,13.414C16.386,13.595 15.922,13.84 15.5,14.141L15.5,13.5L14,13.5L14,15.654C13.342,16.616 12.958,17.778 12.958,19.029C12.958,19.722 13.076,20.388 13.318,21ZM19,13.014L20.211,13.136L20.5,13.226L20.5,9C20.5,8.31 20.22,7.68 19.77,7.23L19.78,7.22L16.06,3.5L15,4.56L17.11,6.67C16.17,7 15.5,7.93 15.5,9C15.5,10.371 16.629,11.5 18,11.5C18.36,11.5 18.69,11.42 19,11.29L19,13.014ZM18,10C17.451,10 17,9.549 17,9C17,8.451 17.451,8 18,8C18.549,8 19,8.451 19,9C19,9.549 18.549,10 18,10ZM12,10L6,10L6,5L12,5L12,10Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelOrder);
export default __webpack_public_path__ + "static/media/fuel-order.21611870.svg";
export { ForwardRef as ReactComponent };